import { HttpContext, HttpContextToken } from '@angular/common/http';

/**
 * Marca una petición para que NO lleve `Authorization`. Obligatorio en `/auth/*`: si se envía un token
 * vencido en esa cabecera el backend responde 401 aunque la ruta sea pública. También evita que el
 * interceptor de errores trate su 401 como "sesión caducada" (en el login significa credenciales inválidas).
 */
export const OMITIR_AUTORIZACION = new HttpContextToken<boolean>(() => false);

export function contextoSinAutorizacion(): HttpContext {
  return new HttpContext().set(OMITIR_AUTORIZACION, true);
}
